import { config } from "@/config"
import { TCSAPIResponse } from "@/types/types"
import axios, { AxiosError, AxiosResponse } from "axios"
import { formatResponse } from "./helpers/formatResponse"
import { ApplicationsResponseData } from "@/types/applications"
import { ActionsAndSubjectsResponse } from "@/types/WorkflowCreate/AppConfiguration"
import { FetchFilterChoicesRequestBody, FilterResponseV2 } from "@/types/WorkflowCreate/filters"
import { FetchAppFieldsRequestBody, FieldsResponse } from "@/types/WorkflowCreate/fields"
import { FetchOptionsChoicesRequestBody, OptionValueResponse } from "@/types/WorkflowCreate/options"
import { LoginMethodsResponse } from "@/types/credentials"

export const ApplicationsAPI = {
  getAll: async (token: string) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/applications`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<ApplicationsResponseData>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<ApplicationsResponseData>(null, error as AxiosError)
    }
  },

  getLoginMethodsOfApp: async (token: string, appId: string) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/applications/${appId}/login-methods`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<LoginMethodsResponse>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<LoginMethodsResponse>(null, error as AxiosError)
    }
  },

  getAvailableSubjects: async (token: string, appId: string) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/applications/${appId}/subjects:available`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<ActionsAndSubjectsResponse[]>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<ActionsAndSubjectsResponse[]>(null, error as AxiosError)
    }
  },

  getAvailableFiltersWithChoices: async (
    token: string,
    appId: string,
    body: FetchFilterChoicesRequestBody
  ) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        data: body,
        url: `${config.apiUrl}/v1/applications/${appId}/filters:available`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<FilterResponseV2[]>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<FilterResponseV2[]>(null, error as AxiosError)
    }
  },

  getAvailableOptionsWithChoices: async (
    token: string,
    appId: string,
    body: FetchOptionsChoicesRequestBody
  ) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        data: body,
        url: `${config.apiUrl}/v1/applications/${appId}/option/values:available`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<OptionValueResponse[]>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<OptionValueResponse[]>(null, error as AxiosError)
    }
  },

  getAppAvailableFields: async (
    token: string,
    appId: string,
    body: FetchAppFieldsRequestBody
  ) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/applications/${appId}/fields:available`,
        data: body,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return formatResponse<FieldsResponse>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<FieldsResponse>(null, error as AxiosError)
    }
  },
}
